import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { Alunos_Socio_Economico } from "../../services/api";

const Socio_economico = (props) => {

    const [data2, setData2] = useState([]);
    const [dataR, setDataR] = useState([]);

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', '', '', 'Seropédica', 'Barra', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha', 'Freguesia', 'Recreio']

    let data_inicio = props.di;
    let data_fim = props.df;

    const fetchData = async () => {
        try {
            // const response = await mensalidade_media(data_inicio, data_fim);
            const response = await Alunos_Socio_Economico('2025-08-29', '2026-03-31');
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    console.log("data2", data2);

    useEffect(() => {
        fetchData();
    }, [data_inicio, data_fim]);


    let chartData = [];

    if (typeof data2 !== 'undefined') {
        chartData = data2.map((item, index) => {
            const row = [unidades[parseInt(item.unidade)]];
            const b50n = parseFloat(item.bolsa_50_novos || 0);
            const b100n = parseFloat(item.bolsa_100_novos || 0);
            const b50r = parseFloat(item.bolsa_50_renovados || 0);
            const b100r = parseFloat(item.bolsa_100_renovados || 0);

            row.push(b50n);
            row.push(b100n);
            row.push(b50r);
            row.push(b100r);

            return row;
        });
    }
    chartData.sort();
    chartData.unshift(['Unidade', 'N50%', 'N100%', 'R50%', 'R100%']);

    // Adiciona linha totalizadora
    if (chartData.length > 1) {
        const totals = ['Total'];
        for (let col = 1; col < chartData[0].length; col++) {
            let sum = 0;
            for (let row = 1; row < chartData.length; row++) {
                sum += Number(chartData[row][col]) || 0;
            }
            totals.push(sum);
        }
        chartData.push(totals);
    }



    const options = {
        allowHtml: true,

    };

    let formatters = [
        {
            type: "NumberFormat",
            column: 1,
            options: {
                prefix: "R$",
                negativeColor: "red",
                negativeParens: true,
            },
        },
        {
            type: "NumberFormat",
            column: 2,
            options: {
                prefix: "R$",
                negativeColor: "red",
                negativeParens: true,
            },
        },
        {
            type: "NumberFormat",
            column: 3,
            options: {
                suffix: " %",
                negativeColor: "red",
                negativeParens: true,
            },
        },
        {
            type: "ColorFormat",
            column: 3,
            ranges: [
                [-10000, 0, "white", "red"],
                [0, 1, "white", "orange"],
                [1, 3, "white", "blue"],
                [3, 10000, "white", "green"],
            ],
        },
    ];

    return (
        <div className="media">
            <strong>Alunos Elegíveis para Bolsas Socioeconômicas</strong>
            <Chart
                chartType="Table"
                version="current"
                width="100%"
                data={chartData}
                options={options}
            />
        </div>
    );
};
export default Socio_economico;